import { LightMode, DarkMode } from './colors';
import { Borders } from './borders';
import { Measures } from './measures';
import { Shadows } from './shadows';
import { Radii } from './radii';
import { Typographies } from './typography';
import { Devices } from './devices';
import { Forms } from './forms';
import { Space } from './space';

export * from './utils/tvar';

export type DesignTokensType = {
  colorScheme: 'light' | 'dark';
  colors: typeof LightMode;
  measures: typeof Measures;
  borders: typeof Borders;
  shadows: typeof Shadows.light;
  radii: typeof Radii;
  typographies: typeof Typographies;
  devices: typeof Devices;
  forms: typeof Forms;
  space: typeof Space;
};

const commonProps = {
  borders: Borders,
  measures: Measures,
  radii: Radii,
  typographies: Typographies,
  devices: Devices,
  forms: Forms,
  space: Space,
};

export const DesignTokenLightMode: DesignTokensType = {
  colorScheme: 'light',
  colors: LightMode,
  shadows: Shadows.light,
  ...commonProps,
};

export const DesignTokenDarkMode: DesignTokensType = {
  colorScheme: 'dark',
  colors: DarkMode,
  shadows: Shadows.dark,
  ...commonProps,
};
